<template>
  <LoadingAnimation v-if="storeGlobal.loadingGlobal" />
  <div v-else class="container superior">
    <div class="row">
      <div class="col">
        <h2 class="text-primary display-5 fw-bold text-start">{{ $t('general.terminosCondiciones') }}</h2>
      </div>
    </div>
    <div class="row mt-4">
      <div class="card card-body">
        <p v-sanitize-html="terminosCondiciones" class="translate"></p>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { ref, onMounted } from 'vue';
  import { useRoute } from 'vue-router';
  import { viajesGrupos } from '@/store_pinia/viajesGrupo';
  import HomeApiService from '@/services/api/skiandnight/HomeApiService';
  import { appGlobalStore } from '@/store_pinia/app';

  const terminosCondiciones = ref('');
  const viajesGruposStore = viajesGrupos();
  const storeGlobal = appGlobalStore();
  const route = useRoute();

  async function fetchTerminosCondiciones() {
    try {
      storeGlobal.loadingGlobal = true;
      const response = await HomeApiService.getTermsConditions();
      terminosCondiciones.value = response.texto;
    } catch (error) {
      console.error('Error al obtener los términos y condiciones:', error);
      terminosCondiciones.value = '';
    } finally {
      storeGlobal.loadingGlobal = false;
    }
  }

  async function initializeTerminosCondiciones() {
    try {
      storeGlobal.loadingGlobal = true;
      if (route.params.viajeId) {
        await viajesGruposStore.fetchViajeSeleccionado(route.params.viajeId);
        const viaje = viajesGruposStore.getViajeSeleccionado;
        terminosCondiciones.value = viaje?.termsConditions || '';
      } else {
        await fetchTerminosCondiciones();
      }
    } catch (error) {
      console.error('Error:', error);
      terminosCondiciones.value = '';
    } finally {
      storeGlobal.loadingGlobal = false;
    }
  }

  onMounted(() => {
    initializeTerminosCondiciones();
  });
</script>

<style scoped lang="scss">
  .card-body {
    border: none;
    padding: 2rem;
  }

  .superior {
    max-width: 1200px;
    margin: 0 auto;
    padding: 25px 0;
    padding-top: 11rem;
  }

  @media only screen and (max-width: 768px) {
    .superior {
      padding: 7rem 15px;
    }

    .card-body {
      padding: 1rem;
    }
  }
</style>
